import { fontStyles } from '@/styles/typography';

import { AlertCircleIcon } from '@/ui/Icons/AlertCircleIcon';

/**
 * Generic alert that renders two elements.
 */
export const GenericOneLineAlert = ({
  leftText,
  leftComponent,
  rightText,
}: {
  leftText: string;
  leftComponent?: React.ReactNode;
  rightText?: string;
}) => (
  <div
    className={fontStyles({
      variant: 'LABEL_MD',
      class: [
        'flex',
        'items-center',
        'py-2.5',
        'px-3',
        'mt-6',
        'text-token-red-1300',
        'bg-token-red-300',
        'rounded-[88px]',
      ],
    })}
  >
    {leftComponent ? (
      leftComponent
    ) : (
      <AlertCircleIcon className="size-4 text-token-red-900 shrink-0" />
    )}
    <span className="text-token-red-1300 mx-3">{leftText}</span>
    <span className="flex-grow text-token-red-1300 text-right">{rightText}</span>
  </div>
);
